import { useMemo } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $initialAccountsStore } from '@lib/store';
import { cn, PaletteUtils, RoutePaths } from '@shared/utils';
import { AccountType } from '@shared/api';
import { NavLink } from './navElement';
import { Icon, Spinner } from '@shared/widgets';
import SwapIcon from '@assets/icons/swap.svg';
import EarthIcon from '@assets/icons/earth.svg';
import CrownIcon from '@assets/icons/crown.svg';
import VcfcIcon from '@assets/icons/logo/logo-vcfc-small.svg';

interface NavigationProps {
  className?: string;
}

export const Navigation = (props: NavigationProps) => {
  const accountStore = useUnit($initialAccountsStore.store);

  const { t } = useTranslation('payments');

  const hasCardAccountSettlement = useMemo(
    () => accountStore.data.some((account) => account.type === AccountType.Card && account.currency === 'EUR'),
    [accountStore.data],
  );
  return (
    <nav className={cn('flex w-full items-start justify-start gap-2', 'max-lg:flex-col', props.className)}>
      <NavLink
        className='max-lg:w-full'
        title={t(`navigation.${PaletteUtils.isVcfcPalette ? 'betweenVcfcAccount' : 'betweenInsigniaAccount'}`)}
        icon={<Icon icon={<SwapIcon width='24' height='24' />} className='-rotate-90' color='white' />}
        to={RoutePaths.paymentsInsignia.onNavigate()}
      />
      <NavLink
        className='max-lg:w-full'
        title={t('navigation.otherBankTransfer')}
        icon={<Icon icon={<EarthIcon />} color='white' />}
        to={RoutePaths.paymentsOther.onNavigate()}
      />
      {accountStore.loading ? (
        <Spinner little />
      ) : (
        hasCardAccountSettlement && (
          <NavLink
            className='max-lg:w-full'
            title={t('navigation.cardAccountSettlement')}
            icon={<Icon icon={PaletteUtils.isVcfcPalette ? <VcfcIcon /> : <CrownIcon />} color='white' />}
            to={RoutePaths.paymentsCard.onNavigate()}
          />
        )
      )}
    </nav>
  );
};
